import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl, FormArray } from '@angular/forms';
import { SWAlertService } from '../../services/swalert.service';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { TSFuntionService } from '../../services/ts-funtion.service';

@Component({
  selector: 'app-setuprecievemail',
  templateUrl: './setuprecievemail.component.html',
  styleUrls: ['./setuprecievemail.component.css']
})
export class SetuprecievemailComponent implements OnInit {
  SetUpReceiveMailForm: FormGroup;//สร้างกลุ่ม Object Data

  constructor(private formBuilder: FormBuilder,
    private Swal: SWAlertService,
    private http: HttpClient,
    private router: Router,
    private System: TSFuntionService
  ) { }

  _fieldTextType: boolean = false;
  _inputType: string;
  _DataCBTitle: any = [];
  _DataCBnDataID: any = [];
  _DataNameSurname: any = [];
  _btnLogin: boolean = true;
  _btnSubmit: boolean = false;
  _divLogin: boolean = false;
  _divDisplay: boolean = false;
  IsShow: boolean = false;

  get _CB_ARR(): FormArray {
    return this.SetUpReceiveMailForm.get('_CB') as FormArray;
  };

  ngOnInit() {
    this._inputType = 'password';
    this.System.OnFocus("txt_UserName", "btn_Login");
    this.System.OnFocus("txt_Password", "btn_Login");
    this.SetUpReceiveMailForm = this.formBuilder.group({
      sUsername: ["", Validators.required],
      sPassword: ["", Validators.required],
      _CB: new FormArray([])
    });

   
  }

  GetCBTitle() {
    this.System.BlockUI();
    let _this = this;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set('nMainID', '1')
    };
    this.http.get<any>(this.System.SiteName + "api/_System/GetCBTitle", httpOptions).toPromise().then(res => {
      if (res) {
        this._DataCBTitle = res;
        let _Title = this.SetUpReceiveMailForm.controls['_CB'] as FormArray;
        res.forEach(w => {
          _Title.push(new FormGroup({
            sTitle: new FormControl(w.sTitle),
            nDataID: new FormControl(w.nDataID),
            ischecked: new FormControl(false)
          }));
        });
        this.EditReceiveMail();
      } else {
        this.Swal.SwAlert.Error(this.Swal.BoxMsg.Title_Error, this.Swal.BoxMsg.Desc_Error_Permission, function () {
          _this.router.navigate(['/login'])
        });
      }
    });
    this.System.UnBlockUI();
  }

  GetName() {
    this.System.BlockUI();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set('sUsername', this.SetUpReceiveMailForm.value.sUsername)
    };
    this.http.get<any>(this.System.SiteName + "api/_System/GetName", httpOptions).toPromise().then(res => {
      if (res) {
        this._DataNameSurname = res;
      }
    });
    this.System.UnBlockUI();
  }

  validateAllFormFields(formGroup: FormGroup) {         //{1}
    Object.keys(formGroup.controls).forEach(field => {  //{2}
      const control = formGroup.get(field);             //{3}
      if (control instanceof FormControl) {             //{4}
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {        //{5}
        this.validateAllFormFields(control);            //{6}
      }
    });
  }

  isFieldValid(field: string) {
    return !this.SetUpReceiveMailForm.get(field).valid && this.SetUpReceiveMailForm.get(field).touched;
  }

  displayFieldCss(field: string) {
    return {
      'has-error': this.isFieldValid(field),
      'has-feedback': this.isFieldValid(field)
    };
  }

  toggleFieldTextType_ConfirmPassword() {
    this._fieldTextType = !this._fieldTextType;
    if (this._fieldTextType) {
      this._inputType = 'text';

    } else {
      this._inputType = 'password';
    }
  }

  Login() {
    // stop here if form is invalid
    if (this.SetUpReceiveMailForm.invalid) {
      this.validateAllFormFields(this.SetUpReceiveMailForm); //{7}
      return;
    } else {
      this.System.BlockUI();
      const headers = new HttpHeaders({
        'Content-Type': 'application/json'
      });
      let formObj = this.SetUpReceiveMailForm.getRawValue();
      let ITEM = JSON.stringify(formObj);
      this.http.post(this.System.SiteName + "api/_System/Login", ITEM, { headers, responseType: 'text' }).toPromise().then(res => {
        this.System.UnBlockUI();
        if (res) {
          this.Swal.SwAlert.Error(this.Swal.BoxMsg.Title_Warning, res, function () { Swal.close(); });
        } else {
          this.GetCBTitle();
          this.GetName();
          this._divLogin = true;
          this._divDisplay = true;
          this._btnLogin = false;
          this._btnSubmit = true;
        }
      });
    }
  }

  Submit() {
    this.System.BlockUI();
    let _this = this;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    let _ObjData = {
      nUserID: this._DataNameSurname[0].nUserID,
      Checkbox: this.SetUpReceiveMailForm.value["_CB"]
    }
    this.http.post<any>(this.System.SiteName + "api/_System/SaveReceiveMail", _ObjData, httpOptions).toPromise().then(res => {
      this.System.UnBlockUI();
      if (res.Status == this.System.SysProcess.SessionExpired) {
        this.System.SessionExpire();
      } else if (res.Status == this.System.SysProcess.Success) {
        this.Swal.SwAlert.Success(this.Swal.BoxMsg.Title_Success, this.Swal.BoxMsg.Desc_Success_Save, function () {
          _this.router.navigate(["/login"]);
        });
      } else {
        this.Swal.SwAlert.Error(this.Swal.BoxMsg.Title_Error, res.Msg, function () { Swal.close(); });
      }
    });
  }

  EditReceiveMail() {
    this.System.BlockUI();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    this.http.get<any>(this.System.SiteName + "api/_System/EditReceiveMail", httpOptions).toPromise().then(res => {
      this.System.UnBlockUI();
      if (res) {
        let FromArraySub = this.SetUpReceiveMailForm.controls['_CB'] as FormArray;
        for (var k = 0; k < res.length; k++) {
          for (var i = 0; i < FromArraySub.length; i++) {
            const FromGroupSub = FromArraySub.at(i) as FormGroup;
            let Data = FromGroupSub.controls["nDataID"].value;
            let SetData = res[k].nDataID == Data;
            if (SetData) {
              FromGroupSub.controls["ischecked"].setValue(true);
            }
          }
        }
      } else {
        let FromArraySub = this.SetUpReceiveMailForm.controls['_CB'] as FormArray;
        for (var i = 0; i < FromArraySub.length; i++) {
          const FromGroupSub = FromArraySub.at(i) as FormGroup;
          FromGroupSub.controls["ischecked"].setValue(false); //set control data
        }
      }
    });
  }

  Back() {
    this.router.navigate(["/login"]);
  }
}
